<template>
  <div id="ProjectVendorList">
    <v-row
      ><v-col cols="12"
        ><h2>Your Current Bidding</h2>
        <v-card class="mx-auto">
          <v-card-title>
            <v-spacer></v-spacer>
            <v-col cols="3"
              ><v-text-field
                outlined
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
              ></v-text-field
            ></v-col>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="dataBiddingProject"
              :loading="loadingProject"
              loading-text="Loading... Please wait"
              :search="search"
              
            >
              <template v-slot:item="{ item }">
                <tr @click="rowClickedCurrent(item)" class="row-project">
                  <td>{{ item.projectCode }}</td>
                  <td>{{ item.subject }}</td>
                  <td>
                    {{ item.purchaser }}
                  </td>
                  <td>
                    {{ item.plant }}
                  </td>
                  <td>{{ moment(item.startDate).format("YYYY-MM-DD") }}</td>
                  <td>{{ moment(item.endDate).format("YYYY-MM-DD") }}</td>
                  <td>
                    <v-chip
                      small
                      dark
                      :color="
                        setChipStatusColor(
                          item.projectStatus,
                          item.vendorProjectStatus
                        )
                      "
                    >
                      {{ item.vendorProjectStatus }}
                    </v-chip>
                  </td>
                  <td>
                    <v-chip
                      dark
                      small
                      :color="setChipBiddingStatusColor(item.biddingStatus)"
                    >
                      {{ item.biddingStatus }}
                    </v-chip>
                  </td>
                
                  <td>
                    <v-btn
                      class="ma-2"
                      :color="
                        selectedRowsCurrent.indexOf(item.projectId) > -1
                          ? 'secondary'
                          : 'primary'
                      "
                      icon
                      @click.stop="rowClickedCurrent(item)"
                    >
                      <v-icon> mdi-eye </v-icon>
                    </v-btn>
                  </td>
                 
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card></v-col
      >
      <v-col cols="12"
        ><h2>Your Bidding History</h2>
        <v-card class="mx-auto">
          <v-card-title>
            <v-spacer></v-spacer>
            <v-col cols="3"
              ><v-text-field
                outlined
                v-model="searchHistory"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                dense
              ></v-text-field
            ></v-col>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="dataBiddingHistory"
              :loading="loadingHistory"
              loading-text="Loading... Please wait"
              :search="searchHistory"
            >
              <template v-slot:item="{ item }">
                <tr @click="rowClickedHistory(item)" class="row-project">
                  <td>{{ item.projectCode }}</td>
                  <td>{{ item.subject }}</td>
                  <td>{{ item.purchaser }}</td>
                  <td>{{ item.plant }}</td>
                  <td>{{ moment(item.startDate).format("YYYY-MM-DD") }}</td>
                  <td>{{ moment(item.endDate).format("YYYY-MM-DD") }}</td>
                  <td>
                    <v-chip
                      dark
                      small
                      :color="
                        setChipStatusColor(
                          item.projectStatus,
                          item.vendorProjectStatus
                        )
                      "
                    >
                      {{ item.vendorProjectStatus }}
                    </v-chip>
                  </td>
                  <td>
                    <v-chip
                      dark
                      small
                      :color="setChipBiddingStatusColor(item.biddingStatus)"
                    >
                      {{ item.biddingStatus }}
                    </v-chip>
                  </td>
                  <td>
                    <v-btn
                      class="ma-2"
                      :color="
                        selectedRowsHistory.indexOf(item.projectId) > -1
                          ? 'secondary'
                          : 'primary'
                      "
                      icon
                      @click.stop="rowClickedCurrent(item)"
                    >
                      <v-icon> mdi-eye </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card></v-col
      ></v-row
    >
  </div>
</template>

<script>
import { _projectservice } from "../services/projectservice";
import { dateFormat } from "../services/utility";

export default {
  name: "ProjectVendorList",
  data: () => ({
    search: "",
    searchHistory: "",
    headers: [
      {
        text: "Project Code",
        align: "start",
        sortable: false,
        value: "projectCode",
      },
      { text: "Subject", value: "subject" },
      {text: "PurchaserName", value: "purchaser" },
      { text: "Company", value: "plant" },
      { text: "Bidding Start Date", value: "startDate" },
      { text: "Bidding End Date", value: "endDate" },
      { text: "Project Status", value: "projectStatus" },
      { text: "Bidding Status", value: "biddingStatus" },
      { text: "Action", value: "action" },
    
  
      
    ],
    vendorId: "",
    dataBiddingProject: [],
    dataBiddingHistory: [],

    selectedBiddingProject: {},
    selectedHistoryProject: {},
    loadingProject: false,
    loadingHistory: false,
    selectedRowsCurrent: [],
    selectedRowsHistory: [],
  }),
  watch: {
    vendorId() {
      this.getBiddingProject();
      this.getBiddingHistory();
    },
    logSelectionCurrentBidding(v) {
      this.selectedRowsCurrent = v;
    },
    logSelectionCurrentHistory(v) {
      this.selectedRowsHistory = v;
    },
  },
  computed: {
    logSelectionCurrentBidding() {
      return this.$store.state.logSelectionCurrentBidding;
    },
    logSelectionCurrentHistory() {
      return this.$store.state.logSelectionHistoryBidding;
    },
  },
  async mounted() {
    this.vendorId = this.$store.state.AppActiveUser.vendorID;
    if (this.vendorId) {
      await this.getBiddingProject();
      await this.getBiddingHistory();
    }
    this.selectedRowsCurrent = this.$store.state.logSelectionCurrentBidding;
    this.selectedRowsHistory = this.$store.state.logSelectionHistoryBidding;
  },
  methods: {
    async rowClickedCurrent(row) {
      await this.toggleSelection(row.projectId, "Current");
      if (row.projectId) {
        this.dataBiddingProject.map((item, index) => {
          item.selected = item === row;
          this.$set(this.dataBiddingProject, index, item);
        });
        this.redirect(row);
      }
    },
    async rowClickedHistory(row) {
      await this.toggleSelection(row.projectId, "History");
      if (row.projectId) {
        this.dataBiddingHistory.map((item, index) => {
          item.selected = item === row;
          this.$set(this.dataBiddingHistory, index, item);
        });
        this.redirect(row);
      }
    },
    toggleSelection(keyID, type) {
      if (type === "Current") {
        if (this.selectedRowsCurrent.includes(keyID)) {
          this.selectedRowsCurrent = this.selectedRowsCurrent.filter(
            (selectedKeyID) => selectedKeyID !== keyID
          );
        } else {
          this.$store.dispatch("AddLogSelectionCurrentBidding", keyID);
        }
      } else {
        if (this.selectedRowsHistory.includes(keyID)) {
          this.selectedRowsHistory = this.selectedRowsHistory.filter(
            (selectedKeyID) => selectedKeyID !== keyID
          );
        } else {
          this.$store.dispatch("AddLogSelectionHistoryBidding", keyID);
        }
      }
    },
    async getBiddingProject() {
      this.loadingProject = true;
      const payload = {
        vendorId: this.vendorId,
      };
      const data = await _projectservice.GetBiddingProjectByVendorId(payload);
      this.dataBiddingProject = Array.isArray(data) ? data : [];
      this.loadingProject = false;
    },

    async getBiddingHistory() {
      this.loadingHistory = true;
      const data = await _projectservice.GetBiddingHistoryByVendorId(this.vendorId);
      this.dataBiddingHistory = Array.isArray(data) ? data : [];
      this.loadingHistory = false;
    },
    setChipStatusColor(status, vendor) {
      let color = "";
      if (vendor == "Open") color = "#2980B9";
      if (vendor == "On Process") color = "warning";
      if (vendor == "Re-Open") color = "#8E44AD";
      if (vendor == "Award") color = "#3498DB";
      if (vendor == "Complete") color = "#2ECC71";

      return color;
    },
    setChipBiddingStatusColor(status) {
      let color = "";
      if (status == "Not Start") color = "primary";
      if (status == "Draft") color = "warning";
      if (status == "Submitted") color = "#2ECC71";

      return color;
    },
    format(date) {
      return dateFormat(date);
    },
    setUrlRedirect(projectId) {
      return `/${this.$i18n.locale}/bidding/main/${projectId}`;
    },
    redirect(item) {
      var url = this.setUrlRedirect(item.projectId);
      this.$router.push(url).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.row-project {
  cursor: pointer;
}
</style>
